import axiosInstance from './axiosInstance';

export async function getTopicAreaComments(topicAreaId: number) {
  const res = await axiosInstance.get(`/api/topic-area/${topicAreaId}/comments`);
  return res.data;
}

export async function createTopicAreaComment(topicAreaId: number, comment: string, parentId: number | null = null) {
  const res = await axiosInstance.post(`/api/topic-area/${topicAreaId}/comments`, { 
    comment,
    parent_id: parentId 
  });
  return res.data;
}

export async function updateTopicAreaComment(commentId: number, comment: string) {
  await axiosInstance.put(`/api/topic-area/comments/${commentId}`, { comment });
}

export async function deleteTopicAreaComment(commentId: number) {
  await axiosInstance.delete(`/api/topic-area/comments/${commentId}`);
} 